module.exports = __webpack_public_path__ + "img/book.2239a8dc.svg";